export default "__VITE_ASSET__8da50a8d__"